/* eslint-disable react/jsx-handler-names */
// Components
import useTranslate from "hooks/useTranslate";
import DescriptionNominal from "components/atoms/DescriptionNominal";
import DescriptionSpin from "../../atoms/DescriptionSpin";
import DescriptionReward from "../../atoms/DescriptionReward";
import DescriptionFreeSpins from "../../atoms/DescriptionFreeSpins";

// Hooks
// Icon
import Close from "../../../assets/icons/glory/close_white.svg?react";

// Types
import { BONUS_TYPES, BonusListType } from "../../../types/Bonus";

import "./styles.sass";

type BonusCardBackProps = {
  bonus: BonusListType;
  clickInfo: () => void;
};

const BonusCardBack = (props: BonusCardBackProps) => {
  const { bonus, clickInfo } = props;
  const isFreeSpin = "nameGameFreeSpin" in bonus;
  const t = useTranslate();

  return (
    <div className="BonusCardBack">
      <div className="BonusCardBack-header">
        {t("bonus.info.header")}
        <Close className="BonusCardBack-header__close" onClick={clickInfo} />
      </div>
      {bonus.type === BONUS_TYPES.REWARD && <DescriptionReward bonus={bonus} />}
      {bonus.type === BONUS_TYPES.SPINS && <DescriptionSpin bonus={bonus} />}
      {(bonus.type === BONUS_TYPES.NOMINAL ||
        bonus.type === BONUS_TYPES.TRIGGER) && (
        <DescriptionNominal bonus={bonus} />
      )}
      {isFreeSpin && bonus.type === BONUS_TYPES.FREE_SPINS && (
        <DescriptionFreeSpins bonus={bonus} />
      )}
    </div>
  );
};

export default BonusCardBack;
